import { render, staticRenderFns } from "./DTHome.vue?vue&type=template&id=71edbb42&"
import script from "./DTHome.vue?vue&type=script&lang=js&"
export * from "./DTHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports